import { AmbassadorProfile } from './authModels';
import { AmbassadorError, Paginator, ServerStatus } from './globalModels';

export type LoyaltyReducerPropsType = {
  loyaltyStatus: ServerStatus;
  pointsData: PointSystemInfo;
  pointsStatus: ServerStatus;
  badgesStatus?: ServerStatus;
  badgesData?: Paginator<BadgeItemType>;
  tiersStatus?: ServerStatus;
  tiersData?: Paginator<LoyaltyTier>;
  tiers?: BadgeItemType[];
  tasksStatus: ServerStatus;
  tasksData?: Paginator<LoyaltyTask>;
  error?: AmbassadorError;
};

export type PointSystemPropsType = {
  pointsInfo: PointSystemInfo;
  ambassadorStatus?: ServerStatus;
  doSetLoyaltyPoints: Function;
};

export type PointSystemInfo = {
  loyalty_points_available: number;
  loyalty_points_earned: number;
  loyalty_points_tier_end: number;
  loyalty_points_tier_start: number;
  loyalty_points_current_tier: LoyaltyTier | null;
  loyalty_points_next_tier: LoyaltyTier | null;
  loyalty_points_current_tier_progress_value: number;
};

export type LoyaltyTier = {
  id: number;
  name: string;
  image: string;
  description: string;
  threshold: number;
  is_active: boolean;
  color: string;
  created_at?: string;
  updated_at?: string;
  extraClass?: string;
};

export enum LoyaltyTierStatMetrics {
  POINTS = 'rewards_points_fulfilled_amount',
  REFERRALS = 'referrals',
  REFERRAL_REVENUE = 'orders_referral_revenue',
}

export enum LoyaltyTierStatMetricsType {
  POINTS = 'points',
  MONETARY = 'monetary',
  COUNT = 'count',
}

export const LoyaltyTierStatMetricTypeCategory: Record<LoyaltyTierStatMetrics, LoyaltyTierStatMetricsType> = {
  [LoyaltyTierStatMetrics.POINTS]: LoyaltyTierStatMetricsType.POINTS,
  [LoyaltyTierStatMetrics.REFERRALS]: LoyaltyTierStatMetricsType.COUNT,
  [LoyaltyTierStatMetrics.REFERRAL_REVENUE]: LoyaltyTierStatMetricsType.MONETARY,
};

export type RecognitionsPropsType = {
  badgesStatus?: ServerStatus;
  badgesData?: Paginator<BadgeItemType>;
  tiersStatus?: ServerStatus;
  tiersData?: Paginator<LoyaltyTier>;
  doGetLoyaltyBadges: Function;
  doGetLoyaltyTiers: Function;
  ambassadorProfile?: AmbassadorProfile;
};

export type badgeConfigType = {
  color: string;
  isTierBadge: boolean;
  pointsRangeFrom: string;
  pointsRangeTo: string;
};

export type BadgeItemType = {
  id: number;
  image: string;
  created_at?: string;
  updated_at?: string;
  description: string;
  is_active: boolean;
  name: string;
  extraClass?: string;
};

export type TaskItemType = {
  taskUid: number;
  taskName: string;
  taskDescription: string;
  extraClass: string;
};

export type LoyaltyTaskCustomization = {
  reward_text?: string;
  reward_color?: string;
  background_color?: string;
  vector_color?: string;
  short_text?: string;
  hover_text?: string;
  hover_background_color?: string;
  hover_color?: string;
  button_text?: string;
  button_background_color?: string;
  button_color?: string;
};

export type LoyaltyTask = {
  uid: number;
  name: string;
  description?: string;
  preview_image: string;
  background_image: string;
  vector_image: string | null;
  vector_file: string | null;
  color: string;
  click_url?: string;
  display_order: number;
  is_active: boolean;
  created_at: string;
  translations: { [key: string]: { [key: string]: string } };
  custom_translations: { [key: string]: { [key: string]: string } };
  customization: LoyaltyTaskCustomization | null;
  points: number;
};
